import { differenceInMinutes, differenceInWeeks, isWeekend } from 'date-fns';
import { MINUTES_IN_DAY } from '../../constants';
import type { ScheduleSolversDisplayConfigType } from '../../types';
import { getDateFromControlValue } from '../../utils/get-date-obj';

export const weekday = ({
  freq = 1,
  endDate,
  startDate,
  userDate,
  scheduleRepeatEnds,
  scheduleRepeatEndsDate,
  scheduleRepeatEndsOccurrences
}: ScheduleSolversDisplayConfigType) => {
  const viewDurationInMinutes = differenceInMinutes(endDate, startDate);
  const fromNowToStartInMinutes = differenceInMinutes(userDate, startDate);

  const timeFromStart = fromNowToStartInMinutes % MINUTES_IN_DAY;

  const isWeekendDay = isWeekend(userDate);

  const weeksBetween = differenceInWeeks(startDate, userDate);

  if (
    scheduleRepeatEnds === 'onDate' &&
    userDate.getTime() >=
      getDateFromControlValue(scheduleRepeatEndsDate).getTime()
  ) {
    return false;
  }

  if (
    scheduleRepeatEnds === 'afterOccurrences' &&
    weeksBetween > freq * Number(scheduleRepeatEndsOccurrences)
  ) {
    return false;
  }

  return (
    timeFromStart <= viewDurationInMinutes &&
    !isWeekendDay &&
    userDate.getTime() > startDate.getTime()
  );
};
